import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CategoryMetricsTotalIndividualParentAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/category/category-metrics-total-individual-parent.aggregate-root.mapper';
import { GetCategoryMetricsTotalsIndividualRequestDto } from '../../../dtos/team-metrics/category/get-category-metrics-totals-individual.request.dto';
import { GetCategoryMetricsTotalsResponseDto } from '../../../dtos/team-metrics/category/get-category-metrics-totals.response.dto';
import { GetCategoryMetricsTotalIndividualQuery } from '../../../queries/team-metrics/category/get-category-metrics-totals-individual.query';

export class GetCategoryMetricsTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetCategoryMetricsTotalIndividualQuery,
    protected readonly mapper: CategoryMetricsTotalIndividualParentAggregateRootMapper
  ) {}

  async get(
    props: GetCategoryMetricsTotalsIndividualRequestDto
  ): Promise<GetCategoryMetricsTotalsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `CategoryMetricsTotalIndividualComponentController.get encountered an error ${error}`
      );
    }
  }
}
